import { render, staticRenderFns } from "./index.vue?vue&type=template&id=668a09ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=668a09ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a09ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668a09ee')) {
      api.createRecord('668a09ee', component.options)
    } else {
      api.reload('668a09ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=668a09ee&scoped=true", function () {
      api.rerender('668a09ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IconSvg/index.vue"
export default component.exports